<template>
  <div>
    <footer class="footer">
      <div class="icon-row">
        <div class="footer-icon">
          <img class="footer-icon-img" src="static/img/footer/footer_icon_1.png" alt="">
          <div class="footer-icon-text">
            <p class="footer-txt-1">正品保障</p>
            <p class="footer-txt-2">100%正品信赖</p>
          </div>
        </div>
        <div class="footer-icon">
          <img class="footer-icon-img" src="static/img/footer/footer_icon_2.png" alt="">
          <div class="footer-icon-text">
            <p class="footer-txt-1">含税销售</p>
            <p class="footer-txt-2">正规采购便捷无忧</p>
          </div>
        </div>
        <div class="footer-icon">
          <img class="footer-icon-img" src="static/img/footer/footer_icon_3.png" alt="">
          <div class="footer-icon-text">
            <p class="footer-txt-1">专业物流</p>
            <p class="footer-txt-2">闪电配送满就包邮</p>
          </div>
        </div>
        <div class="footer-icon">
          <img class="footer-icon-img" src="static/img/footer/footer_icon_4.png" alt="">
          <div class="footer-icon-text">
            <p class="footer-txt-1">便捷支付</p>
            <p class="footer-txt-2">一键采购资金安全</p>
          </div>
        </div>
      </div>
      <div class="footer-content">
        <div class="service-intro">
          <div class="footer-item">
            <div class="footer-left-code"><img src="static\img\index\img\img_13.png" alt=""></div>
            <div class="footer-right-item">
              <div class="servece-type">
                <div class="servece-type-info" v-for="(guide, index) in guideArr.help" :key="index">
                  <ul>
                    <li><router-link to="#">{{ guide.name }}</router-link></li>
                    <li v-for="(item, index) in guide.article" :key="index" @click="goFooter(item)"><router-link to="#">{{
                      item.art_name }}</router-link></li>
                  </ul>
                </div>
              </div>
              <div class="footer-describe">
                <div class="footer-left-describe">
                  <p>互联网药品信息服务资格证编号：{{ footerTxt.fuwu_zige }} &emsp; ICP备案证书号：<a class="beiAn" target="_blank"
                      href="https://beian.miit.gov.cn/">{{ footerTxt.site_beian }}</a></p>
                  <p><img style="width:16px;height:16px;margin-right:10px" src="static\img\index\police.png" />
                    <a href="https://beian.mps.gov.cn/#/query/webSearch?code=45090202000468\" rel="noreferrer" target="_blank">桂公网安备45090202000468号</a >
                    <!-- <a href="https://beian.mps.gov.cn/#/query/webSearch?code=45090202000468\" rel="noreferrer" target="_blank"  class="beiAn">桂公网安备45090202000468号</a> -->
                  </p>
                  <p>{{ footerTxt.site_copyright }}</p>
                  <p>{{ footerTxt.con_describe }}</p>
                </div>
                <div class="footer-right-describe">
                  <div class="footer-describe-code"><img src="static\img\index\img\img_12.png"
                      style="width: 90px;height:90px;" alt=""></div>
                  <div class="footer-describe-txt">
                    <p>官方微信</p>
                    <p>微信扫描二维码时刻关注我们，不错过每一次优惠活动！</p>
                  </div>
                </div>
              </div>
              <!-- <div class="clearfix"></div>
                   <div class="friend-link">
                     <div class="friend-link-item">
                       <ul>
                         <li v-for="(link, index) in moreLink" :key="index">
                           <span :class="[linkItemClass, {'link-last-item': index === 9}]">{{link}}</span>
                         </li>
                       </ul>
                     </div>
                   </div>
                   <div class="copyright">
                     <p>Copyright © 2020 by Dream <a href="https://github.com/allChangelove"><Icon type="social-github"></Icon></a> <span>本项目仅供学习参考</span></p>
                   </div>-->
            </div>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import { getFooter } from "@/api/commonApi";
export default {
  name: 'Footer',
  data() {
    return {
      linkItemClass: 'link-item',
      guideArr: [],
      url: 'http://b2b_api.yeswedo.com.cn/',
      footerTxt: ''
    };
  },
  mounted() {
    this.footerList();
  },
  methods: {
    footerList() {
      /**footer */
      let _this = this;
      getFooter()
        .then(res => {
          console.log("获取footer", res);
          this.guideArr = res.data;
          this.footerTxt = res.data.footer;
          console.log("获取guideArr", this.guideArr);
        })
        .catch(err => {
          console.log(err);
        });
    },
    goFooter(item) {
      //  跳转帮助中心
      console.log(255, item);
      this.$router.push({
        path: "/Helps/HelpLogin",
        query: {
          id: item.art_id
        }
      });
    },
  }

};
</script>

<style lang="less" scoped>
/*****************************底 部 开 始*****************************/
.footer {
  width: 100%;
  background-color: #F4F4F4;

  .icon-row {
    margin: 0 auto;
    width: 1200px;
    height: 100px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    justify-content: space-around;

    .footer-icon {
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;

    }

    .footer-icon-img {
      width: 50px;
      height: 50px;
      border-radius: 50%;
      box-shadow: 0px 2px 4px 0px rgba(123, 123, 123, 0.32);
    }

    .footer-icon-text {
      padding-left: 10px;
    }

    .footer-txt-1 {
      font-size: 20px;
      font-family: PingFangHK-Regular, PingFangHK;
      font-weight: 400;
      color: #333333;
    }

    .footer-txt-2 {
      font-size: 14px;
      font-family: PingFangHK-Regular, PingFangHK;
      font-weight: 400;
      color: #666666;
    }
  }

  .footer-content {
    width: 100%;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    /* justify-content: flex-end;*/
  }

  .service-intro {
    width: 100%;
    height: 489px;
    background: #fff;

    .footer-item {
      width: 1200px;
      margin: 0 auto;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
    }

    .footer-left-code {
      width: 240px;
      height: 370px;
      margin: 47px 60px 0 0;

      img {
        width: 240px;
        height: 370px;
      }
    }

    .footer-right-item {
      width: 960px;

      .servece-type {
        margin: 54px auto 30px auto;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        /* flex-direction: row;
        justify-content: flex-start;*/
      }

      .servece-type-info {
        flex: 1;
        color: #666666;
      }

      .servece-type-info ul {
        list-style: none;
      }

      .servece-type-info li {
        font-size: 16px;
        font-family: PingFangHK-Regular, PingFangHK;
        font-weight: 400;
        color: #666666;
        line-height: 43px;

        a {
          color: #666;
        }
      }

      .servece-type-info li:first-child {
        font-size: 18px;
        font-family: PingFangHK-Medium, PingFangHK;
        font-weight: 500;
        color: #333333;
        line-height: 25px;

        a {
          color: #333333;
        }
      }
    }

    .footer-describe {
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-pack: justify;
      -ms-flex-pack: justify;
      justify-content: space-between;
      border-top: 1px solid #E2E2E2;
      padding-top: 25px;

      .footer-left-describe {
        width: 557px;

        p {
          font-size: 12px;
          font-family: PingFangHK-Regular, PingFangHK;
          font-weight: 400;
          color: #666666;
          line-height: 36px;
        }
      }

      .footer-right-describe {
        width: 252px;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;

        .footer-describe-code {
          width: 90px;
          height: 90px;

          img {}
        }

        .footer-describe-txt {
          padding-left: 20px;

          p:first-child {
            font-size: 16px;
            font-family: PingFangHK-Medium, PingFangHK;
            font-weight: 500;
            color: #333333;
            line-height: 22px;
            padding: 8px 0;
          }

          font-size: 12px;
          font-family: PingFangHK-Regular,
          PingFangHK;
          font-weight: 400;
          color: #666666;
          line-height: 17px;
        }
      }
    }
  }

}

.beiAn {
  color: #666666;
}

.beiAn:hover {
  color: #147A38;
}

/*****************************底 部 结 束*****************************/
</style>



// WEBPACK FOOTER //
// src/components/footer/Footer.vue